import React from 'react';
import houseImg from '../assets/ngoinha.svg';

const InfoPanel = ({ isExpanded, onStart }) => {
  return (
    <div className={`info-panel ${isExpanded ? 'full' : 'sidebar'}`}>
      <div className="panel-content-wrapper">
        <div className="info-content">
          <img src={houseImg} alt="Smart Home" className="house-image" />
          
          <h1 className="title">
            Easy living with your<br /> smart home 💡
          </h1>
          <p className="subtitle">
            Get your smart devices in one place and manage all of these with a few taps.
          </p>

          {/* Chỉ hiện nút Start khi đang ở chế độ Full màn hình */}
          {isExpanded && (
            <button className="start-btn" onClick={onStart}>
              Get Started &rarr; 
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;